import { IsolatedScanThermal } from "../types/types"
import { genericRequest, isolatedScanThermalRoute } from "./service"

export const getIsolatedScanThermal = async (sectionScanId: number): Promise<IsolatedScanThermal[] | Error> => {
  return await genericRequest({ url: `${isolatedScanThermalRoute}/isolated_scan_thermals/${sectionScanId}`, method: "GET" })
}

/**
 * Creates isolated scan thermal entity in cloud db.
 * 
 * @param isolatedScanThermal to upload
 * @param sectionScanId of the related section
 * 
 * @returns uploaded isolated scan thermal
 */
export const addIsolatedScanThermal = async (isolatedScanThermal: IsolatedScanThermal, sectionScanId: number): Promise<IsolatedScanThermal | Error> => {
  return await genericRequest({ url: `${isolatedScanThermalRoute}/${sectionScanId}`, method: "POST", body: JSON.stringify(isolatedScanThermal) })
}